<mat-dialog-content class="dialog-content">
    <h2>Are you sure?</h2>
    <p>This action cannot be undone.</p>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
    <button mat-stroked-button color="accent" (click)="onCancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="onConfirm()">Yes</button>
</mat-dialog-actions>
